// extracted by mini-css-extract-plugin
export default {"form":"EventForm_form__Z099U","actions":"EventForm_actions__i3Tgh"};